import PlateTextContainer from "./container";

export default PlateTextContainer;
